import { useMemo } from 'react'

import { RangeValue } from '../types'

interface UseCallCountFilterProps {
  selectedCallCount: RangeValue
  onCallCountChange: (value: RangeValue) => void
}

export const useCallCountFilter = ({
  selectedCallCount,
  onCallCountChange,
}: UseCallCountFilterProps) => {
  const rangeValue = useMemo<RangeValue>(() => {
    return {
      min: 0,
      max: 20,
      gte: selectedCallCount.gte ?? null,
      lte: selectedCallCount.lte ?? null,
    }
  }, [selectedCallCount])

  return {
    rangeValue,
    onChange: onCallCountChange,
    isLoaded: true,
  }
}
